import { Link } from "react-router-dom";
import { navLinks } from "@/mocks/site";

export default function NotFound() {
  return (
    <div className="mx-auto flex max-w-7xl flex-col items-center px-4 py-24 text-center md:px-6">
      <p className="font-heading text-7xl font-black text-primary-500/40 md:text-9xl">404</p>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-50">这个页面没有找到</h1>
      <p className="mt-2 max-w-md text-sm text-foreground-400">
        它可能已经下线，或者链接输入有误。不妨从下面的入口继续浏览吧。
      </p>
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 font-label text-sm uppercase tracking-wide text-foreground-950 transition-colors hover:bg-primary-400"
        >
          <i className="ri-home-4-line text-lg" />
          返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300/60 px-6 py-3 font-label text-sm uppercase tracking-wide text-foreground-100 transition-colors hover:border-primary-400 hover:text-primary-400"
        >
          <i className="ri-search-line text-lg" />
          搜索电影
        </Link>
      </div>
      <div className="mt-10 flex flex-wrap justify-center gap-2">
        {navLinks.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className="rounded-full bg-background-100 px-4 py-2 text-sm text-foreground-300 transition-colors hover:bg-background-200/70 hover:text-primary-400"
          >
            {link.label}
          </Link>
        ))}
      </div>
    </div>
  );
}